export const fieldKeys = ['sku', 'name', 'price', 'stock', 'category', 'image'] as const

export type FieldKey = (typeof fieldKeys)[number]
export type RawRow = Record<string, unknown>
export type ColumnMapping = Record<FieldKey, string>
export type RowStatus = 'valid' | 'warning' | 'excluded'
export type IssueSeverity = 'warning' | 'error'

export interface RowIssue {
  code: string
  severity: IssueSeverity
  message: string
}

export interface CatalogRow {
  sourceRowNumber: number
  sku: string
  name: string
  supplierPriceCents: number | null
  regularPriceCents: number | null
  stock: number | null
  category: string
  imageUrl: string
  status: RowStatus
  issues: RowIssue[]
}

export interface PricingRules {
  markupPercent: number
  taxPercent: number
  roundingIncrement: 1 | 5 | 10 | 100
}

export const emptyMapping = (): ColumnMapping => ({
  sku: '',
  name: '',
  price: '',
  stock: '',
  category: '',
  image: '',
})
